import React from 'react';
import { Box, Button, ButtonProps } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import AddIcon from '@mui/icons-material/Add';
import { useIsBelowMd } from 'hooks/use-is-below-md';
import { DataGridEmpty } from 'components/data-grid/components/data-grid-empty';
import clsx from 'clsx';
import shared from '../../shared.module.scss';

export const AddNewButton: React.FC<React.PropsWithChildren<ButtonProps>> = (props) => {
  const { t } = useTranslate();
  return (
    <Button variant={'contained'} color={'primary'} startIcon={<AddIcon />} {...props}>
      {t('add-new')}
    </Button>
  );
};

interface EmptySlotProps {
  onCreate: () => void;
}

export const EmptySlot: React.FC<React.PropsWithChildren<EmptySlotProps>> = ({ onCreate }) => {
  // N1 (R3, R6): below md the grid's header holds the add; an empty list says
  // so as every other list does (a second, centred add read as a toolbar
  // with no list under it)
  const isBelowMd = useIsBelowMd();
  if (isBelowMd) {
    return <DataGridEmpty className={clsx('wrapper', shared.emptyCompact)} />;
  }
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <AddNewButton onClick={onCreate} />
    </Box>
  );
};
